// central.eu — SPA app root.
// Owns dees-domtools smartrouter routing between the landing and console views,
// and restores/persists the bright/dark theme via domtools.themeManager.

import {
  DeesElement,
  customElement,
  html,
  css,
  state,
  cssManager,
  domtools,
  type TemplateResult,
} from '@design.estate/dees-element';
import { t } from '../ceu-theme.js';
import './ceu-landing.js';
import './ceu-console.js';

@customElement('ceu-app')
export class CeuApp extends DeesElement {
  @state() accessor route: string = window.location.pathname === '/console' ? '/console' : '/';

  private router!: domtools.plugins.smartrouter.SmartRouter;

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        display: block;
        min-height: 100vh;
        background: ${t.canvas};
        color: ${t.ink};
      }
    `,
  ];

  public async connectedCallback(): Promise<void> {
    await super.connectedCallback();
    const dt = await this.domtoolsPromise;

    // Restore theme preference (falls back to system preference).
    try {
      const saved = localStorage.getItem('ceu_theme');
      if (saved === 'bright' || saved === 'light') {
        dt.themeManager.goBright();
      } else if (saved === 'dark') {
        dt.themeManager.goDark();
      } else {
        await dt.themeManager.enableAutomaticGlobalThemeChange();
      }
    } catch (e) {
      /* ignore */
    }

    // Routing.
    this.router = dt.router;
    this.router.on('/', async () => {
      this.route = '/';
    });
    this.router.on('/console', async () => {
      this.route = '/console';
    });
    this.addEventListener('ceu-navigate', (ev: Event) => {
      const path = (ev as CustomEvent).detail?.path ?? '/';
      void this.router.pushUrl(path);
      window.scrollTo({ top: 0 });
    });
    await this.router.pushUrl(window.location.pathname);
  }

  public render(): TemplateResult {
    return this.route === '/console'
      ? html`<ceu-console></ceu-console>`
      : html`<ceu-landing></ceu-landing>`;
  }
}
